import { Checkbox } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Confirmation from '../../../../assets/Confirmation/Confirmation';
import remove from '../../../images/trash.png';
import { useContext } from 'react';
import { IndividualWorkPlanContext } from '../../../../utils/context';


const EditableTableTasks = ({ item, i, setDataForTable }) => {

    const { id, addIndividualPlanI, editIndividualPlanI, deleteIndividualPlanI, } = useContext(IndividualWorkPlanContext)


    const [formData, setFormData] = useState(item)
    const [check, setCheck] = useState(!!item.performed)
    const [confirmation, setConfirmation] = useState(null)


    useEffect(() => {
        setFormData(prev => ({ ...prev, performed: check ? 1 : 0 }))
    }, [check])

    useEffect(() => {
        !!item && setFormData(item)
    }, [item])

    const handleEdit = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({ ...prev, [name]: value }))
    }

    const handleCheck = () => {
        setCheck(!check)
    }

    const handleRowFetch = async () => {
        if (!formData.id) {
            await addIndividualPlanI(formData, id)
            setFormData(item)
        }
        else editIndividualPlanI(formData)
    }
    const deleteItem = (id) => (e) => {
        e.stopPropagation()
        setConfirmation(id)
    }
    const acceptConfirmation = () => {
        deleteIndividualPlanI(confirmation, formData)
        setConfirmation(null)
        setDataForTable([])
    }

    const rejectConfirmation = () => {
        setConfirmation(null)
    }
    return (
        <tr key={item.id} onBlur={() => handleRowFetch()}>
            <td className="tg-s6z2">{i + 1}</td>
            <td className="tg-yw4l">
                <textarea
                    disabled
                    name='task'
                    value={formData.task}
                    onChange={handleEdit}
                    style={{
                        width: '100%',
                        background: 'transparent',
                        border: 'none',
                        resize: 'none',
                    }}
                />
            </td>
            <td className="tg-yw4l">
                <textarea
                    disabled
                    name='term'
                    value={formData.term}
                    onChange={handleEdit}
                    style={{
                        width: '100%',
                        background: 'transparent',
                        border: 'none',
                        resize: 'none',
                    }}
                />
            </td>
            <td className="tg-yw4l">
                <Checkbox checked={check} onClick={handleCheck} disabled />
            </td>
            {/* <td onClick={deleteItem(item.id)}>
                <img
                    src={remove}
                    alt="*"
                />
            </td> */}
            {confirmation && (
                <Confirmation
                    top="30px"
                    left="40px"
                    title="Уверены что хотите удалить запись?"
                    acceptConfirmation={acceptConfirmation}
                    rejectConfirmation={rejectConfirmation}
                />
            )}
        </tr>
    )
}


export default EditableTableTasks